import { Link } from "react-router-dom";

export const Logo = ({ dark = false, to = "/" }) => (
  <Link to={to} className="flex items-center gap-2.5" data-testid="brand-logo-link">
    <span className="block h-10 w-10 overflow-hidden rounded-xl bg-white ring-1 ring-slate-200">
      <img src="/images/logo.jpeg" alt="Taxmandi" className="h-full w-full scale-[1.9] object-cover" style={{ objectPosition: "50% 22%", transformOrigin: "50% 27%" }} />
    </span>
    <span className="leading-none">
      <span className={`font-display text-xl font-extrabold tracking-tight ${dark ? "text-white" : "text-tm-green"}`}>Tax<span className="text-tm-gold">mandi</span></span>
      <span className={`block text-[9px] font-semibold tracking-[0.25em] ${dark ? "text-white/60" : "text-slate-500"}`}>CONNECT · LEARN · GROW</span>
    </span>
  </Link>
);
